
<div class="pe-se-title" >
  Page Background & Width
</div>
<mat-form-field class="pe-se-input">
  <mat-label>Background Color</mat-label>
  <input matInput
         [(ngModel)]="layoutSettings.color"
         [(colorPicker)]="layoutSettings.color"
         [style.background]="layoutSettings.color">
</mat-form-field>

<div class="pe-se-input">
  <mat-label>max width</mat-label>
  <mat-slider class="pe-se-slider"
              [(ngModel)]="layoutSettings.maxWidth"
              thumbLabel
              tickInterval="1"
              min="1020"
              max="1440"></mat-slider>
 </div>

